import React from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";


import {AttachFileIcon} from "../icons/AttachFileIcon";
import {ImageGalleryPreview} from "../ImageGalleryPreview";
import {Button} from "../Button";
import {FileUploadsManager} from "../../../stores/models/FileUploadsManager";
import {TaskReportFileMeta} from "../../../stores/taskLists/TaskReportModel";

import {FileProvider} from "../../../utils/file/FileProvider";

import './AttachFiles.css';

export interface AttachFilesProps {
    fileUploadsManager: FileUploadsManager<TaskReportFileMeta>;
    fileProvider: FileProvider;
    className?: string,
    accept?: string;
    label?: string,
}

export const AttachFiles = observer((
    {
        fileUploadsManager,
        fileProvider,
        className,
        accept = "*/*",
        label = intl.get("taskReportEdit.attachFile.button").d("Attach file"),
    }: AttachFilesProps
) => {
    const handleAdd = () => {
        fileProvider.uploadFile({multiple: true, accept: accept}, (newFiles) => {
            if (newFiles) {
                fileUploadsManager.addFiles(newFiles)
            }
        });
    };
    return (
        <>
            <Button
                className={className}
                onClick={handleAdd}
                Icon={AttachFileIcon}
                size="sm"
                text={label}
                style="inline"
                type="primary"
            />
            {
                fileUploadsManager.entries.length
                    ? (
                        <ImageGalleryPreview
                            className="AttachFiles_images"
                            onAdd={handleAdd}
                            urls={fileUploadsManager.entries.map(entry => ({
                                path: entry.meta?.path,
                                thumbPath: entry.meta?.thumbPath,
                                src: entry.previewUrl,
                            }))}
                            onRemove={fileUploadsManager.removeFileAt}
                        />
                    )
                    : null
            }
        </>
    )
});
